import { getTranslationLang } from '@aipb/util/translation';
import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { SetupHandler } from './setup.handler';
import { CONFIG_FRAME, CONFIG_PROJECT } from '@aipb/util/di';

@Injectable({
  providedIn: 'root'
})
export class TranslationHandler extends SetupHandler {
  private transloco = inject(TranslocoService);
  private project = inject(CONFIG_PROJECT);
  private frame = inject(CONFIG_FRAME);

  constructor() {
    super('🌍 translation.handler');
  }

  handle() {
    const lang = getTranslationLang(this.project) || this.frame.defaultLanguage;
    this.transloco.setActiveLang(lang);
    this.addLogMessage(`use ${lang} translation`);
  }
}
